<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-03-06 09:47:51
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-03-06 16:05:12
 * @FilePath: \crm-product\src\views\dms\views\rebate\reward-channel-cost-customer\form\details.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'details_table',
  extends: TablePage,
  data() {
    return {
      params: {},
    };
  },
  props: {
    propsObj: Object,
  },
  async created() {
    console.log(this.propsObj);
    this.params = { feePoolCode: this.propsObj.row.feePoolCode };
    await this.getConfigList('detail_list');
  },
  methods: {

  },
};
</script>
